'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity} from 'react-native';
import { observer, inject } from 'mobx-react';

import ReactDOM from 'react-dom';
import {CityList as CityListComp} from '@qnpm/f_citylist';

@inject(stores => {
    const {searchDataStore} = stores,
        {getArrCity, setCityComp, locationHandler} = searchDataStore;

    return {
        getArrCity,
        setCityComp,
        locationHandler
    };
})

@observer
class CityList extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        const dom = ReactDOM.findDOMNode(this);
        this.initCityList(dom)
    }
    initCityList = (dom) => {
        this.destCityList = new CityListComp(dom, {
            listType: 'dest',
            locationHandler: this.props.locationHandler,
            hysdk: hysdk,
            godEye: GodEye,
            page_source: 'flight_tejia_rn_arr',
            successCallback: this.props.getArrCity,
            moduleRadioMap: {
                innerDestHotRankList: false,
                interDestHotRankList: false
            },
            source: 'lowprice'
        });

        this.destCityList.init();
        this.props.setCityComp('destCityListComp', this.destCityList);
    };

    render() {

        return (
            <View style={{zIndex: 200}}/>
        )
    }
}

export default CityList;
